import {SUCCESS} from "../../../../constants/action-postfix";
import {HIRING_PLAN_REQUEST} from "../hiringPlanReducer";



const initialState = null;

export const dataReducer = (state = initialState, action) => {
    switch (action.type) {
        case `${HIRING_PLAN_REQUEST}${SUCCESS}`:
            return action.payload;
        default:
            return state;
    }
};